module.exports = __webpack_public_path__ + "static/img/info-img.7093e5e0.png";